import OrganizationCard from "./OrganizationCard";

function VolunteerCalls() {
  const volunteers = [
    {
      name: "BENEVOLES COLLECTE A TOULOUSE",
      objective:
        "Nous recherchons des bénévoles pour organiser des collectes de dons et/ou pour d'autres missions à Toulouse. Si vous êtes intéressé(e), veuillez remplir ce formulaire.",
      verificationDate: "25/12/2024",
      link: "https://forms.gle/Wd8JDQVMpbfiVGxeA",
    },
    {
      name: "RECENSEMENT DE SOLUTIONS D'ACCUEIL",
      objective:
        "Nous sommes à la recherche de personne sur l'île étant en mesure d'héberger des volontaires. Dans un premier temps, on enverra les réponses à l'ARS (Agence Régionale de la Santé) Nous comptons...",
      verificationDate: "18/12/2024",
      link: "https://docs.google.com/forms/d/e/1FAIpQLScN7dQVDGYrFlDOVJu-n7L61l_F6WvG22DwQLy-o280y8JzXg/viewform",
    },
    {
      name: "RECENSEMENT MAHORAIS VOLONTAIRE",
      objective:
        "Ce formulaire a pour objectif de recenser les personnes volontaires et prêtes à se rendre à Mayotte pour apporter leur aide face à la situation d'urgence actuelle.",
      verificationDate: "18/12/2024",
      link: "https://docs.google.com/forms/d/e/1FAIpQLSfYu8sY2WK8oQNCo9Y-tyOUuZDhg13Rav3Ydo_FBo8YOc_vgA/viewform",
    },
  ];

  return (
    <div className="volunteers-grid">
      {volunteers.map((volunteer, index) => (
        <OrganizationCard
          key={index}
          organization={volunteer.name}
          objective={volunteer.objective}
          verificationDate={volunteer.verificationDate}
          imageUrl={volunteer.imageUrl}
          link={volunteer.link}
        />
      ))}
    </div>
  );
}

export default VolunteerCalls;
